import {CustomerFeedbackContainer} from './CustomerFeedbackContainer';

export class CustomerFeedback {
    constructor(containerSelector = '.customer-feedback-container') {
        this.containerSelector = containerSelector;
        this.initialize();
    }

    initialize() {
        const feedbackContainers = document.querySelectorAll(this.containerSelector);

        for (let container of feedbackContainers) {
            new CustomerFeedbackContainer(container);
        }
    }
}